import React from "react";

import { CircularProgress } from "@mui/material";
import { Constants as GridConstants } from "Components/AppGrid/shipeezi-new-grid";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { FiTrash2 } from "react-icons/fi";

import { DefaultTooltip } from "../../../../../../../../../components/Generic/Tooltip";
import useStyles from "./styles";

interface Props {
  ids: number[];
  loading: boolean;
  handleOnClick: (id: number[]) => void;
}

const DeleteBrandButton = (props: Props) => {
  const { ids, handleOnClick, loading } = props;

  const { t: translate } = useTranslation();
  const classes = useStyles();

  if (loading) return <CircularProgress size={20} />;

  return (
    <DefaultTooltip title={translate("delete")} placement="top">
      <div>
        <FiTrash2
          size={GridConstants.defaultRowActionSize}
          className={classNames(classes.button, classes.deleteButton)}
          data-cy="delete-button"
          onClick={() => {
            handleOnClick(ids);
          }}
        />
      </div>
    </DefaultTooltip>
  );
};

export default DeleteBrandButton;
